import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/api/firebase/firebase.config";
import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { collectionDoc } from "@/api/collectionRef/collectionOperations";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { authOptionProps, authOptions } from "../utils/customAuthOptions";
import { CustomSignInButton } from "./CustomAuthButton";
import { useAuthPersistState } from "@/store/auth/auth.store";
import { SignUpAnonymously } from "./SignUpAnonymously";
import { Button, Flex, Text } from "@radix-ui/themes";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { Profile } from "@/models/database/profiles/profile.model";
import i18next from "i18next";

export const FirebaseAuthMethods: FC<{
  email: string;
}> = ({ email }) => {
  const navigate = useNavigate();
  const setProfile = useCurrentUserProfile((s) => s.setUser);
  const setUser = useAuthPersistState((state) => state.setUser);
  const cloudFunctionUrl =
    "https://europe-west1-spike-ba886.cloudfunctions.net/app/oauth/";

  const handleGoogleSignIn = async () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      const res = await firebase.auth().signInWithPopup(provider);
      const profileRef = await collectionDoc.profiles(
        res.user.uid,
        brand.tenantId
      );
      const profile = profileRef.data() as Profile;

      if (profile) {
        localStorage.removeItem("authEmailLocal");
        setProfile(profile);
        setUser(res.user);
        navigate("/dashboard");
      }
      if (!profile || res.additionalUserInfo.isNewUser) {
        localStorage.setItem("signUpMethod", "google");
        localStorage.setItem("authEmailLocal", email);
        navigate("/enter-username");
      }
    } catch (error) {
      console.error("Error signing in with Google: ", error);
    }
  };

  const isSignUp = window.location.pathname.includes("signup");

  return (
    <Flex direction="column" gap="3">
      {brand.hasAuth.quickSignUp && (
        <Flex>
          <SignUpAnonymously />
        </Flex>
      )}

      {brand.hasAuth.google && (
        <Button
          variant="outline"
          style={{ width: "100%" }}
          size="3"
          onClick={handleGoogleSignIn}
        >
          <Text size="2">{i18next.t("auth.methods.button")} Google</Text>
        </Button>
      )}

      {Array.isArray(authOptions) &&
        authOptions.map((option: authOptionProps) => {
          const { logo, suffix, longText, shortText } = option;
          if ((logo && longText) || shortText) {
            return (
              <CustomSignInButton
                logo={logo}
                url={`${cloudFunctionUrl}${suffix}`}
                longText={longText}
                shortText={shortText}
                type={shortText}
                key={suffix}
              />
            );
          }
        })}
    </Flex>
  );
};
